/* ============================================================
   Maison Broderie — global.js
   Interactions de base du thème vierge.
   ============================================================ */
(function () {
  'use strict';

  // --- Galerie produit : clic sur miniature -> image principale ---
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('.product__thumbnails img');
    if (!thumb) return;
    var main = document.querySelector('.product__image');
    if (main) {
      main.src = thumb.src.replace('width=200', 'width=1200');
      main.alt = thumb.alt;
    }
  });

  // --- Ajout au panier en AJAX ---
  var productForm = document.querySelector('.product__form');
  if (productForm) {
    productForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var button = productForm.querySelector('[name="add"]');
      var originalText = button ? button.textContent : '';
      if (button) { button.disabled = true; button.textContent = '…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(serializeForm(productForm))
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          if (button) { button.disabled = false; button.textContent = '✓ Ajouté'; }
          setTimeout(function () { if (button) button.textContent = originalText; }, 1800);
        })
        .catch(function () {
          if (button) { button.disabled = false; button.textContent = originalText; }
        });
    });
  }

  function serializeForm(form) {
    var data = { items: [{}] };
    var id = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    data.items[0].id = id ? Number(id.value) : null;
    data.items[0].quantity = qty ? Number(qty.value) : 1;
    return data;
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }
})();
